import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { Logo } from '@ui/components/Logo';
import { api, setToken } from '../lib/api';

export function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const login = useMutation({
    mutationFn: () =>
      api<{ accessToken: string }>('/login', {
        method: 'POST',
        body: { email, password },
      }),
    onSuccess: (session) => {
      setToken(session.accessToken);
      /*
       * إعادة تحميل كاملة لا تنقّل داخلي.
       *
       * الجذر يقرأ الرمز مرة واحدة عند الإقلاع ليقرر أي شجرة يعرض. التنقّل
       * الداخلي لا يعيد تقييم ذلك، فتبقى شاشة الدخول ظاهرة رغم نجاح الدخول.
       */
      window.location.href = '/';
    },
  });

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email && password) login.mutate();
  };

  return (
    <div className="console-login">
      <form className="console-login-card" onSubmit={submit}>
        <div className="console-login-head">
          <Logo size={44} />
          <div className="console-login-title">لوحة منصة GoyOne</div>
          <p className="small mute">للدخول بحساب فريق المنصة</p>
        </div>

        {login.isError && (
          <div className="alert alert-danger mb-4">
            {login.error instanceof Error ? login.error.message : 'تعذّر الدخول.'}
          </div>
        )}

        <div className="field">
          <label className="label" htmlFor="p-email">
            البريد الإلكتروني
          </label>
          <input
            id="p-email"
            className="input num"
            type="email"
            dir="ltr"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            autoFocus
          />
        </div>

        <div className="field mt-4">
          <label className="label" htmlFor="p-password">
            كلمة المرور
          </label>
          <input
            id="p-password"
            className="input"
            type="password"
            dir="ltr"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </div>

        <button
          className="btn btn-primary mt-4"
          type="submit"
          disabled={!email || !password || login.isPending}
          style={{ width: '100%', justifyContent: 'center' }}
        >
          {login.isPending ? 'جارٍ الدخول' : 'دخول'}
        </button>
      </form>
    </div>
  );
}
